import { Drawer } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  NOTIFICATION_CREATE,
  NOTIFICATION_EDIT,
  NOTIFICATION_VIEW,
} from '../../../constants/NotificationsConst';
import { validateUserSession } from '../../../utils/authUtils';
import { selectedHotelSelector } from '../../property/propertySlice';
import NotificationCreate from './notification-create/NotificationCreate';
import NotificationList from './notification-list/NotificationList';
import NotificationView from './notification-view/NotificationView';
import './Notifications.scss';

const Notifications = (props) => {
  const { permissions, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const [state, setState] = useState({
    type: NOTIFICATION_CREATE,
    status: false,
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const history = useHistory();

  useEffect(() => {
    validateUserSession(history);
  }, [history]);

  const [viewState, setViewState] = useState({
    type: NOTIFICATION_VIEW,
    status: false,
    obj: null,
  });

  useEffect(() => {
    setViewState({
      ...viewState,
      status: false,
    });
  }, [selectedHotel]);

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const onDrawerToggle = (type, status, obj) => {
    setState({ type: type, status: status, obj: obj });
  };

  const onViewToggle = (type, status, obj) => {
    setViewState({ type: type, status: status, obj: obj });
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case NOTIFICATION_CREATE:
        return (
          <NotificationCreate
            toggleDrawer={onDrawerToggle}
            hotelId={selectedHotel}
            showLoader={showLoader}
          />
        );
      case NOTIFICATION_EDIT:
        return (
          <NotificationCreate
            toggleDrawer={onDrawerToggle}
            obj={state.obj}
            hotelId={selectedHotel}
            editing={true}
            showLoader={showLoader}
          />
        );
      default:
        break;
    }
  };

  const switchViewContent = (inpState) => {
    switch (inpState.type) {
      case NOTIFICATION_VIEW:
        return (
          <NotificationView
            obj={viewState.obj}
            permissions={permissions}
            onViewToggle={onViewToggle}
            onDrawerToggle={onDrawerToggle}
            hotelId={selectedHotel}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      <Drawer
        anchor={'right'}
        open={state.status}
        onClose={toggleDrawer(false)}
        className='right-drawer'
      >
        {switchDrawerContent(state)}
      </Drawer>
      {viewState.status && <>{switchViewContent(viewState)}</>}
      {!viewState.status && (
        <div className='container mt-3'>
          <div className='row d-flex'>
            <div className='col-md-6 mt-3 mb-5'>
              <span className='page-title'>Notifications</span>
            </div>
          </div>
          <div className='row mx-2 d-flex mt-3'>
            <div className='card shadow'>
              <NotificationList
                onDrawerToggle={onDrawerToggle}
                onViewToggle={onViewToggle}
                hotelId={selectedHotel}
                permissions={permissions}
                onsetPage={(e) => setPage(e)}
                page={page}
                onsetRowsPerPage={(e) => setRowsPerPage(e)}
                rowsPerPage={rowsPerPage}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Notifications;
